/**
 * @generated SignedSource<<9b97de84a1d60b8ef21a20063bb0a343>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "availableVacanciesModel"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "myScheduleFilterModel"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "myScheduleModel"
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeServices",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = {
        "kind": "Literal",
        "name": "first",
        "value": 5
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "myScheduleFilterModel"
        },
        (v5 /*: any*/),
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "myScheduleModel"
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v8 = [
        (v4 /*: any*/)
    ], v9 = {
        "kind": "InlineFragment",
        "selections": (v8 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v14 = [
        (v11 /*: any*/),
        (v4 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assignedEntity",
        "plural": false,
        "selections": [
            (v7 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": (v14 /*: any*/),
                        "storageKey": null
                    }
                ],
                "type": "SchedulableAsset",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v14 /*: any*/),
                        "storageKey": null
                    }
                ],
                "type": "SchedulableUser",
                "abstractKey": null
            },
            (v9 /*: any*/)
        ],
        "storageKey": null
    }, v16 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        },
        (v4 /*: any*/)
    ], v17 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": (v16 /*: any*/),
        "storageKey": null
    }, v18 = [
        (v12 /*: any*/),
        (v4 /*: any*/)
    ], v19 = {
        "alias": null,
        "args": null,
        "concreteType": "Schedule",
        "kind": "LinkedField",
        "name": "schedule",
        "plural": false,
        "selections": (v18 /*: any*/),
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleShiftConnection",
        "kind": "LinkedField",
        "name": "simultaneousScheduleShift",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ScheduleShiftEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ScheduleShift",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignedEntity",
                                "plural": false,
                                "selections": [
                                    (v7 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            (v4 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "asset",
                                                "plural": false,
                                                "selections": [
                                                    (v12 /*: any*/),
                                                    (v11 /*: any*/),
                                                    (v4 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "SchedulableAsset",
                                        "abstractKey": null
                                    },
                                    (v9 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVacant",
        "storageKey": null
    }, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v25 = [
        (v5 /*: any*/),
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "availableVacanciesModel"
        }
    ], v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v12 /*: any*/)
        ],
        "storageKey": null
    }, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    }, v29 = [
        (v5 /*: any*/),
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "createdDate": "DESC"
            }
        },
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "status": {
                    "eq": "PUBLISHED"
                }
            }
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "DashboardPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrentUser",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "availableVacanciesModel",
                                            "variableName": "availableVacanciesModel"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "myScheduleFilterModel",
                                            "variableName": "myScheduleFilterModel"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "myScheduleModel",
                                            "variableName": "myScheduleModel"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "SchedulePanel_user"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TimePanel_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FaqPanel_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v2 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Operation",
            "name": "DashboardPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrentUser",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SchedulableUser",
                                    "kind": "LinkedField",
                                    "name": "schedulableEntity",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "schedulable",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v6 /*: any*/),
                                            "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "scheduleItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v9 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v11 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v13 /*: any*/)
                                                                    ],
                                                                    "type": "PlannedAbsence",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v13 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShift",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v12 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                (v11 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v13 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleShift",
                                                                            "kind": "LinkedField",
                                                                            "name": "scheduleShift",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                (v13 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ScheduleShiftAssigneeReplacement",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/),
                                                (v24 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v6 /*: any*/),
                                            "filters": [],
                                            "handle": "connection",
                                            "key": "MySchedulePanel_scheduleItems",
                                            "kind": "LinkedHandle",
                                            "name": "scheduleItems"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v25 /*: any*/),
                                            "concreteType": "ScheduleShiftConnection",
                                            "kind": "LinkedField",
                                            "name": "availableVacantShifts",
                                            "plural": false,
                                            "selections": [
                                                (v23 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShift",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v15 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v25 /*: any*/),
                                            "filters": [],
                                            "handle": "connection",
                                            "key": "AvailableVacanciesPanel_availableVacantShifts",
                                            "kind": "LinkedHandle",
                                            "name": "availableVacantShifts"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeReportingUser",
                                    "kind": "LinkedField",
                                    "name": "timeReportingUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 4
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "order",
                                                    "value": {
                                                        "month": "DESC"
                                                    }
                                                }
                                            ],
                                            "concreteType": "TimeReportConnection",
                                            "kind": "LinkedField",
                                            "name": "timeReports",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TimeReportEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeReport",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v26 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "month",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "order",
                                                                            "value": [
                                                                                {
                                                                                    "timestampId": "DESC"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "TimeReportHistory",
                                                                    "kind": "LinkedField",
                                                                    "name": "history",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "message",
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": "history(order:[{\"timestampId\":\"DESC\"}])"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeReportSummaryByEmployment",
                                                                    "kind": "LinkedField",
                                                                    "name": "employmentSummaries",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Employment",
                                                                            "kind": "LinkedField",
                                                                            "name": "employment",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EmploymentSetting",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "employmentSetting",
                                                                                    "plural": false,
                                                                                    "selections": (v16 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeReportSummaryByEmploymentAndEvent",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventSummaries",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v27 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isWork",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TimeReportSummaryByEmploymentAndEventPartsSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "nonRegularPartsSummary",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v27 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "unit",
                                                                                                    "value": "SECOND"
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "TimeSpanUnitValue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "duration",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v28 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": "duration(unit:\"SECOND\")"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "unit",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v28 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeTrack",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeTracks",
                                                                    "plural": true,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeReportAddition",
                                                                    "kind": "LinkedField",
                                                                    "name": "additions",
                                                                    "plural": true,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "timeReports(first:4,order:{\"month\":\"DESC\"})"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v29 /*: any*/),
                    "concreteType": "FaqPostConnection",
                    "kind": "LinkedField",
                    "name": "faqPosts",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FaqPostEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FaqPost",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "answer",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "question",
                                            "storageKey": null
                                        },
                                        (v26 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ITaggedItemConnection",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ITaggedItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v4 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tagId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Tag",
                                                                    "kind": "LinkedField",
                                                                    "name": "tag",
                                                                    "plural": false,
                                                                    "selections": (v18 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "useFaqPostTags_tags",
                                            "kind": "LinkedHandle",
                                            "name": "tags"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "IFileConnection",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "IFileEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "contentType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "directory",
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/),
                                                                (v12 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "size",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "storageId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "useFaqPostAttachments_attachments",
                                            "kind": "LinkedHandle",
                                            "name": "attachments"
                                        },
                                        (v7 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v22 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v24 /*: any*/)
                    ],
                    "storageKey": "faqPosts(first:5,order:{\"createdDate\":\"DESC\"},where:{\"status\":{\"eq\":\"PUBLISHED\"}})"
                },
                {
                    "alias": null,
                    "args": (v29 /*: any*/),
                    "filters": [
                        "order",
                        "where"
                    ],
                    "handle": "connection",
                    "key": "FaqPostList_faqPosts",
                    "kind": "LinkedHandle",
                    "name": "faqPosts"
                }
            ]
        },
        "params": {
            "cacheID": "8793fe56f00ea0a65e86e7c4b16707cb",
            "id": null,
            "metadata": {},
            "name": "DashboardPageQuery",
            "operationKind": "query",
            "text": "query DashboardPageQuery(\n  $availableVacanciesModel: GetRunningScheduleRequestInput!\n  $myScheduleModel: GetRunningScheduleRequestInput!\n  $myScheduleFilterModel: ScheduleItemsFilterInput\n) {\n  currentUser {\n    activeServices\n    me {\n      ...SchedulePanel_user_OGAIV\n      ...TimePanel_user\n      id\n    }\n    id\n  }\n  ...FaqPanel_query\n}\n\nfragment AvailableVacanciesPanel_schedulableUser_v0zOM on SchedulableUser {\n  availableVacantShifts(first: 5, model: $availableVacanciesModel) {\n    totalCount\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...ScheduleShiftList_scheduleShiftConnection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FaqPanel_query on Query {\n  ...FaqPostList_query_C0e3K\n}\n\nfragment FaqPostListItem_faqPost on FaqPost {\n  id\n  answer\n  question\n  status\n  ...useFaqPostTags_faqPost\n  attachments {\n    edges {\n      node {\n        __typename\n        contentType\n        directory\n        id\n        name\n        size\n        storageId\n        url\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FaqPostList_query_C0e3K on Query {\n  faqPosts(first: 5, order: {createdDate: DESC}, where: {status: {eq: PUBLISHED}}) {\n    edges {\n      node {\n        id\n        ...FaqPostListItem_faqPost\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MySchedulePanel_schedulableUser_2xcYcs on SchedulableUser {\n  scheduleItems(first: 5, model: $myScheduleModel, filter: $myScheduleFilterModel) {\n    edges {\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PlannedAbsence {\n          end\n          reasonEvent {\n            color\n            name\n            id\n          }\n          start\n        }\n        ... on ScheduleShift {\n          start\n        }\n        ... on ScheduleShiftAssigneeReplacement {\n          reasonEvent {\n            name\n            id\n            color\n          }\n          start\n          end\n          scheduleShift {\n            id\n            start\n          }\n        }\n        ...ScheduleShiftCard_scheduleShift\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MyTimeReportsPanel_timeReportingUser on TimeReportingUser {\n  id\n  timeReports(order: {month: DESC}, first: 4) {\n    edges {\n      node {\n        id\n        status\n        month\n        history(order: [{timestampId: DESC}]) {\n          message\n          id\n        }\n        employmentSummaries {\n          employment {\n            employmentSetting {\n              title\n              id\n            }\n            id\n          }\n          eventSummaries {\n            event {\n              id\n              name\n            }\n            isWork\n            nonRegularPartsSummary {\n              event {\n                id\n                name\n              }\n              duration(unit: SECOND) {\n                value\n              }\n            }\n            unit\n            value\n          }\n        }\n        timeTracks {\n          id\n        }\n        additions {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SchedulePanel_user_OGAIV on User {\n  schedulableEntity {\n    id\n    schedulable\n    ...MySchedulePanel_schedulableUser_2xcYcs\n    ...AvailableVacanciesPanel_schedulableUser_v0zOM\n  }\n}\n\nfragment ScheduleShiftCard_scheduleShift on ScheduleShift {\n  __typename\n  id\n  assignedEntity {\n    __typename\n    ... on SchedulableAsset {\n      asset {\n        color\n        id\n      }\n    }\n    ... on SchedulableUser {\n      user {\n        color\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    title\n    id\n  }\n  schedule {\n    name\n    id\n  }\n  end\n  simultaneousScheduleShift {\n    edges {\n      node {\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableAsset {\n            id\n            asset {\n              name\n              color\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  start\n  isVacant\n}\n\nfragment ScheduleShiftList_scheduleShiftConnection on ScheduleShiftConnection {\n  edges {\n    node {\n      id\n      start\n      ...ScheduleShiftCard_scheduleShift\n    }\n  }\n}\n\nfragment TimePanel_user on User {\n  timeReportingUser {\n    active\n    id\n    ...MyTimeReportsPanel_timeReportingUser\n  }\n}\n\nfragment useFaqPostTags_faqPost on FaqPost {\n  id\n  tags {\n    edges {\n      node {\n        __typename\n        id\n        tagId\n        tag {\n          name\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "12e4c0107a1f0fc19936c0c9257c4ae3";
export default node;
